
export interface ShoppingCartDto {
  cartId: number;
  userId?: string;
  createdAt?: string;
  items: ShoppingCartItemDto[];
  subtotal: number;
  totalItems: number;
}

export interface ShoppingCartItemDto {
  wineId: number;
  wineName?: string;
  wineFileId?: number;
  imageUrl?: string;
  quantity: number;
  unitPrice: number;
  wineExternalCode?: string;
  lineTotal: number;
}
